











import {Component, Vue} from 'vue-property-decorator';
import {debounce} from 'quasar';
import {AnimationStore} from '../store';

@Component
export default class ItemViewHeroImage extends Vue {
	get imagePath() {
		return AnimationStore?.itemViewHeroImageProps?.heroImagePath ?? '';
	}


	/**
	 * calls transitionEnd after a debounce
	 *
	 * We're going to get multiple transitionend events in rapid succession
	 * from all the individual style property changes. Add a debounce to only
	 * proceed when they've settled down. Otherwise, or if the debounce
	 * wait time isn't long enough, you'll see "navigation cancelled" errors.
	 */
	transitionEndDebounced = debounce(this.transitionEnd.bind(this), 50);

	transitionEnd(event: Event) {
		if(typeof AnimationStore.itemViewHeroImageProps?.transitionEndCallback === 'function') {
			AnimationStore.itemViewHeroImageProps.transitionEndCallback();
		}
		this.$emit('transitionend', event);
	}
}
